import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchHoaMembers } from "../../services/api/Member";
import PageHeader from "../Header";

interface HoaMember {
  id: number;
  name_of_association: string;
  icon?: string;
  president_name?: string;
  name_of_sec?: string;
  address?: string;
  email?: string;
  phone?: string;
  website?: string;
}

const MemberUnit: React.FC = () => {
  const { slug } = useParams();
  const [members, setMembers] = useState<HoaMember[]>([]);
  const [selectedMember, setSelectedMember] = useState<HoaMember | null>(null);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await fetchHoaMembers(`hoa-members/${slug}`);
        const fetchedMembers = response?.data?.data?.[0]?.hoa_members || [];
        console.log("fetchedMembers",fetchedMembers);
        debugger

        // ✅ First added → first show, last added → last show
        const orderedMembers = [...fetchedMembers].sort((a, b) => a.id - b.id);

        setMembers(orderedMembers);
      } catch (error) {
        console.error("Failed to fetch HOA members", error);
      }
    };

    if (slug) fetchMembers();
  }, [slug]);

  return (
    <div className="max-w-full mx-auto">
      {/* ================= PAGE HEADER ================= */}
      <PageHeader title={slug?.replace(/-/g, " ")} slug={slug}/>

      {/* ================= MEMBERS GRID ================= */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 py-12 md:px-16 px-5">
        {members.map((item) => (
          <div
            key={item.id}
            onClick={() => setSelectedMember(item)}
            className="cursor-pointer bg-white rounded-lg border shadow-sm hover:shadow-lg transition"
          >
          <div
            className="
              text-center
              px-3 py-4
              font-semibold
              uppercase
              text-sm
              rounded-t-lg
              min-h-[80px]
              flex items-center justify-center
              bg-gradient-to-r
              from-blue-900
              to-indigo-900
              text-white
              leading-snug
            "
>
              {item.name_of_association}
            </div>

              {item.icon && (
            <div className="flex items-center justify-center h-[130px] p-4">
                <img
                  src={item.icon}
                  alt={item.name_of_association}
                  className="w-24 h-24 object-contain"
                />
            </div>
              )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MemberUnit;
